import { useRef, useCallback } from 'react';

const useInterval = (interval: number, actionToCall: () => void) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const start = useCallback(() => {
    intervalRef.current = setInterval(() => {
      actionToCall();
    }, interval);
  }, [interval, actionToCall]);

  const stop = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  return [start, stop];
};

export default useInterval;
